import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/ticket-management',
            name: 'admin-ticket-management',
            component: () => import(/* webpackChunkName: "page-admin-mall-management-ticket-management" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "票务商品管理"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "微商城管理"
                                        },
                                        {
                                                  name: "票务商品管理"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
